import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["openForm"],
    _excluded2 = ["text"];
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useButtonProps } from './hooks';
export var ButtonContainer = function ButtonContainer(_ref) {
  var openForm = _ref.openForm,
      buttonProps = _objectWithoutProperties(_ref, _excluded);

  var _useButtonProps = useButtonProps(buttonProps),
      text = _useButtonProps.text,
      computedButtonProps = _objectWithoutProperties(_useButtonProps, _excluded2);

  return /*#__PURE__*/React.createElement(Button, _extends({}, computedButtonProps, {
    onClick: openForm
  }), text);
};